export default __webpack_public_path__ + "static/media/tabletphone.b0e8a52a.png";